<template>
  <div>
    <layout-header title="Trámite EFS Consolidado (Solvencia)" subtitle="Informe consolidado sobre la situación económica de las ESI">
      <ets-button v-if="isAllowed" icon="add" @click="generateReport" />
    </layout-header>
    <ets-page>
      <template v-if="isAllowed">
        <ets-alert type="info">Presentar antes de: 12 mayo (T1), 11 de agosto (T2), 11 de noviembre (T3) y 11 de febrero (T4)</ets-alert>
        <download-section v-if="isAllowed" ref="downloadSection" procedure="solvencyconsolidated" />
      </template>
      <forbidden v-else />
    </ets-page>
  </div>
</template>

<script>
import { mapState } from "vuex";
import LayoutHeader from "@/components/Layout/LayoutHeader";
import DownloadSection from "@/components/Download/DownloadSection";
import Forbidden from "@/components/Forbidden";

export default {
  name: "PageSolvencyConsolidated",
  components: {
    LayoutHeader,
    DownloadSection,
    Forbidden
  },
  computed: {
    ...mapState(["userPermissions"]),
    isAllowed() {
      return this.userPermissions && this.userPermissions.EAFI_E_ProcedureSEAFI;
    }
  },
  methods: {
    generateReport() {
      this.$refs.downloadSection.initGenerationNewFile();
    }
  }
};
</script>
